<template>
  <div>
    <panel title="Профайл">
      <legend class="mb-3">Профайл:</legend>
      <div class="row mb-3">
        <label class="form-label col-form-label col-md-3">Аватар</label>
        <div class="col-md-9">
          <div>
            <img class="imagePreviewWrapper  mt-3 mb-5" :src="previewImage" alt="" @click="selectImage()"
              onerror="javascript:this.src='/images/avatar/user.png'">
            <input ref="fileInput" type="file" class="form-control" @input="pickFile()">
          </div>
        </div>
      </div>
      <validation-observer ref="form">
        <form>
          <fieldset>
            <validation-provider #default="{ errors }" name="name" rules="required|min:6|max:16" vid="name">
              <div class="row mb-3">
                <label class="form-label col-form-label col-md-3">Имя</label>
                <div class="col-md-9">
                  <input type="text" v-model="user.name" class="form-control" placeholder="Имя">
                  <small class="text-danger">{{ errors[0] }}</small>
                </div>
              </div>
            </validation-provider>
            <validation-provider #default="{ errors }" name="email" rules="required|email|min:4|max:32" vid="email">
              <div class="row mb-3">
                <label class="form-label col-form-label col-md-3">Email</label>
                <div class="col-md-9">
                  <input :disabled="user.email_verified_at.charAt(0) != 'E'" type="email" v-model="user.email"
                    class="form-control" placeholder="Email">
                  <small class="text-danger">{{ errors[0] }}</small>
                </div>
              </div>
            </validation-provider>
            <div class="row mb-3">
              <label class="form-label col-form-label col-md-3">Статус </label>
              <div class="col-md-9">
                <div class="input-group" id="default-daterange">
                  <input type="text" disabled v-model="user.email_verified_at" class="form-control" placeholder="Email">
                  <div v-if="user.email_verified_at.charAt(0) == 'E'" class="input-group-text cursor-pointer btn-info"
                    @click="sendMail()"> <i class="far  fa-square-check pe-1 "></i> Подтвердить
                  </div>
                </div>
              </div>
            </div>

            <div class="row mb-3" v-if="!user.telegram_id">
              <label class="form-label col-form-label col-md-3">Telegram </label>
              <div class="col-md-9">
                <div class="mb-15px">
                  <a href="https://t.me/fastsmm_ru_bot?start" target="_blank" class="btn btn-info">
                    <i class="fab fa-lg fa-fw fa-telegram"></i>
                    <span> Привязать Telegram</span>
                  </a>
                </div>
              </div>
            </div>
            <div class="row mb-3" v-else>
              <label class="form-label col-form-label col-md-3">Telegram </label>
              <div class="col-md-9">
                  <input :disabled="true" type="number" v-model="user.telegram_id"
                    class="form-control" >
                </div>
            </div>

            <div class="row ">
              <label class="form-label col-form-label col-md-3">Темная тема</label>
              <div class="col-md-9">
                <div class="">
                  <div class="form-check form-switch ms-auto mb-0">
                    <input type="checkbox" class="form-check-input" name="app-theme-dark-mode" id="appThemeDarkMode"
                      v-on:change="toggleDarkMode" v-model="user.theme" />
                    <label class="form-check-label" for="appThemeDarkMode">&nbsp;</label>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-md-7 offset-md-3 mt-3">
                <button :disabled="loading" class="btn btn-primary w-120px   me-3" @click="saveUser()">
                  <i v-show="loading" class="fas fa-circle-notch fa-spin"></i>
                  <span v-show="!loading"> Сохранить</span>
                </button>
                <button :disabled="loading" class="btn btn-default " @click="fetchData()">
                  Отмена
                </button>

              </div>
            </div>
          </fieldset>
        </form>
      </validation-observer>


    </panel>
  </div>
</template>

<script>
import HTTP from "../http";
import {show_error, show_message} from "../message";
import AppOptions from '../config/AppOptions.vue'
import {ValidationProvider, ValidationObserver} from 'vee-validate';
import axios from "axios";


export default {
  components: {
    ValidationProvider,
    ValidationObserver
  },
  data() {
    return {
      appOptions: AppOptions,
      loading: false,
      user: {},
      previewImage: null,
      showButtons: null,
    };
  },

  created() {
    if (this.$route.query.token) {
      console.log('loginByToken')
      this.linkTelegram(this.$route.query.token);
    } else {
      console.log('fetchData')
      this.fetchData();
    }
  },

  methods: {
    linkTelegram(token) {
      this.$insProgress.start();
      this.loading = true;
      HTTP()
        .post("/auth/link_telegram", {
          token: token
        })
        .then((resp) => {
          console.log('resp=', resp)
          show_message(this.$notify, 'Успех')
          setTimeout(this.fetchData, 1500)
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data);
        })
        .finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
    sendMail() {
      this.$swal({
        html: "\
			<div style='text-align:center'>\
				Выслать Вам письмо <br> \
                чтобы подтвердить этот Email?\
			</div>\
			",
        buttonsStyling: false,
        confirmButtonText: 'Отправить письмо',
        confirmButtonClass: 'btn me-2 btn-info',
        showLoaderOnConfirm: true,
      }).then(() => {
        HTTP()
          .post("/send-email-confirm")
          .then((response) => {
            console.log(response)
          })
          .catch(() => {
          }).finally(() => {
            this.loading = false;
            this.$swal({
              html: "\
                            <div style='text-align:center'>\
                                Письмо отправлено.<br> \
                                Проверьте свой почтовый ящик. <br> \
                                Если  письма нет проверьте папку спам <br>\
                                Если письмо не приходит, поменяйте почту и <br>\
                                отправьте письмо еще раз\
                            </div>\
                            ",
              buttonsStyling: false,
              confirmButtonText: 'Закрыть',
              confirmButtonClass: 'btn me-2 btn-info',
              showLoaderOnConfirm: true,
            })
            this.$insProgress.finish();
          })
      })
      /*
      if (confirm("Выслать письмо, чтобы подтвердить этот Email?")) {
          HTTP()
              .post("/send-email-confirm")
              .then((response) => {
                  console.log(response)
              })
              .catch((error) => {
                  this.loading = false;
                  show_error(
                      this.$notify, error.response.data
                  );
              }).finally(() => {
                  this.$insProgress.finish();
              })
      }
      */
    },
    sleep(ms) {
      return new Promise((resolve) => {
        setTimeout(resolve, ms);
      });
    },
    saveUser() {
      this.loading = true;
      this.$insProgress.start();
      HTTP()
        .put("/user/0", {
          email: this.user.email,
          name: this.user.name,
          theme: this.user.theme
        })
        .then(async (response) => {
          this.user = response.data;
          window.eventBus.$emit('user.update', response.data)
          localStorage.setItem('user', JSON.stringify(response.data))
          if (this.showButtons) {
            await this.sleep(500)
            this.saveAvatar();
          }
        })
        .catch((error) => {
          show_error(this.$notify, this.$refs.form, error.response.data)
        }).finally(() => {
          this.loading = false;
          this.$insProgress.finish();
        });
    },
    cancelBtn() {
      this.previewImage = '/images/avatar/' + this.user.avatar
      this.showButtons = null;
    },
    selectImage() {
      console.log('select image')
      this.$refs.fileInput.click()
    },
    pickFile() {
      let input = this.$refs.fileInput
      let file = input.files
      if (file && file[0]) {
        let reader = new FileReader
        reader.onload = e => {
          this.previewImage = e.target.result
        }
        reader.readAsDataURL(file[0])
        this.showButtons = true;
      }
    },
    saveAvatar() {
      this.loading = true;
      this.$insProgress.start();
      this.isUploadingImage = true
      const config = {
        headers: {
          'content-type': 'multipart/form-data',
          Authorization: `Bearer ${localStorage.access_token}`,
        },
      }
      const data = new FormData()
      data.append('avatar', this.$refs.fileInput.files[0])
      axios.post('/api/avatar', data, config)
        .then(response => {
          this.user = response.data
          window.eventBus.$emit('user.update', response.data)
          localStorage.setItem('user', JSON.stringify(response.data))

        }).catch(error => {
          show_error(this.$notify, null, error.response.data)
        })
        .finally(() => {
          console.log('finally')
          this.showButtons = null
          this.loading = false;
          this.$insProgress.finish();
        })
    },
    toggleDarkMode: function (e) {
      if (e.target.checked) {
        document.body.classList.add('dark-mode');
      } else {
        document.body.classList.remove('dark-mode');
      }
    },

    fetchData() {
      this.$insProgress.start();
      this.loading = true;
      HTTP()
        .get("/user")
        .then((response) => {
          this.loading = false;
          this.user = response.data;
          this.previewImage = '/images/avatar/' + this.user.avatar
          console.log(this.user.avatar)
        })
        .catch((error) => {
          this.loading = false;
          show_error(
            this.$notify, error.response.data
          );
        }).finally(() => {
          this.$insProgress.finish();
        })
    },
  },
};
</script>

<style>
.imagePreviewWrapper {
  width: 250px;
  height: 250px;
  cursor: pointer;
  object-fit: contain;
  border-radius: 50rem !important;
  object-fit: cover;
}

.w-120px {
  width: 120px !important;
}
</style>